'use client'

import { Label } from '@/components/ui/label'
import { Slider } from '@/components/ui/slider'

interface LabSliderProps {
  label: string
  value: number
  min: number
  max: number
  step: number
  decimals?: number
  suffix?: string
  onChange: (value: number) => void
}

export function LabSlider({
  label,
  value,
  min,
  max,
  step,
  decimals = 2,
  suffix = '',
  onChange,
}: LabSliderProps) {
  return (
    <div className="space-y-1.5">
      <div className="flex items-center justify-between">
        <Label className="text-xs font-medium">{label}</Label>
        <span className="font-geistmono text-muted-foreground text-[11px] tabular-nums">
          {value.toFixed(decimals)}
          {suffix}
        </span>
      </div>
      <Slider
        aria-label={label}
        value={[value]}
        min={min}
        max={max}
        step={step}
        onValueChange={([nextValue]) => {
          if (typeof nextValue === 'number') {
            onChange(nextValue)
          }
        }}
      />
    </div>
  )
}
